(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3541],{

/***/ 26699:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vendedores/[...slug]",
      function () {
        return __webpack_require__(23296);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 50153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ faq; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/disclosure/disclosure.js
var disclosure = __webpack_require__(6512);
// EXTERNAL MODULE: ./node_modules/common-tags/es/index.js + 40 modules
var es = __webpack_require__(40865);
// EXTERNAL MODULE: ./components/hoc/conditional-wrapper/index.ts + 1 modules
var conditional_wrapper = __webpack_require__(70997);
// EXTERNAL MODULE: ./components/icons/ChevronDown.tsx
var ChevronDown = __webpack_require__(33068);
// EXTERNAL MODULE: ./components/molecules/prose/index.ts + 1 modules
var prose = __webpack_require__(60257);
;// CONCATENATED MODULE: ./components/molecules/faq/Faq.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        ",
        '\n        [&:has([id^="headlessui-disclosure-button"])>[id^="headlessui-disclosure-panel"]_[id^="headlessui-disclosure-button"]]:u-body\n        [&:has([id^="headlessui-disclosure-button"])>[id^="headlessui-disclosure-panel"]_[id^="headlessui-disclosure-button"]]:u-body--s\n        [&:has([id^="headlessui-disclosure-button"])>[id^="headlessui-disclosure-panel"]_[id^="headlessui-disclosure-button"]]:normal-case\n        ',
        "\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n              u-headline u-headline--h4 flex w-full items-center justify-between py-2 text-left\n              ",
        "\n              ",
        "\n            "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n              transition\n              ",
        "\n              ",
        "\n            "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                py-4 u-body u-body--xs\n                ",
        "\n                ",
        "\n              "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






var VARIANTS = {
    black: {
        heading: "bg-primary-900 text-typo-alternative px-4",
        arrow: "",
        body: "px-4 bg-typo-alternative text-typo-secondary u-body u-body--xs"
    },
    white: {
        heading: "bg-bg-secondary text-typo-primary px-4",
        arrow: "text-secondary-500",
        body: "px-4 bg-typo-alternative text-typo-secondary u-body u-body--xs"
    },
    gray: {
        heading: "bg-primary-100 text-typo-primary px-4",
        arrow: "",
        body: "px-4 bg-typo-alternative text-typo-secondary u-body u-body--xs"
    },
    transparent: {
        heading: "text-typo-primary",
        arrow: "text-secondary-500",
        body: ""
    }
};
var isFAQ = function(children) {
    var // TODO: Corregir tipos
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    ref;
    return (children === null || children === void 0 ? void 0 : (ref = children.type) === null || ref === void 0 ? void 0 : ref.displayName) === "Faq";
};
/**
 * Faq
 */ var Faq = function(param) {
    var question = param.question, _headingType = param.headingType, headingType = _headingType === void 0 ? "p" : _headingType, _variant = param.variant, variant = _variant === void 0 ? "black" : _variant, Icon = param.Icon, children = param.children, _className = param.className, className = _className === void 0 ? "" : _className, open = param.open, _classNames = param.classNames, classNames = _classNames === void 0 ? {} : _classNames;
    var childIsFAQ = isFAQ(children) || Array.isArray(children) && children.every(function(child) {
        return isFAQ(child);
    });
    var isString = typeof children === "string";
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure */.p, {
        as: "div",
        className: (0,es/* oneLine */.f9)(_templateObject(), childIsFAQ ? "" : "border-b border-primary-100", className),
        defaultOpen: open,
        children: function(param) {
            var open = param.open;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(disclosure/* Disclosure.Button */.p.Button, {
                        as: headingType,
                        role: "button",
                        className: (0,es/* oneLine */.f9)(_templateObject1(), VARIANTS[variant].heading, (ref = classNames === null || classNames === void 0 ? void 0 : classNames.header) !== null && ref !== void 0 ? ref : ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(conditional_wrapper/* default */.Z, {
                                condition: Boolean(Icon),
                                wrapper: function(children) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-flex flex-row place-items-center gap-4",
                                        children: [
                                            Icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                                width: 16,
                                                height: 16
                                            }),
                                            children
                                        ]
                                    });
                                },
                                children: question
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDown/* ChevronDown */._, {
                                className: (0,es/* oneLine */.f9)(_templateObject2(), open ? "-rotate-180" : "rotate-0", VARIANTS[variant].arrow)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure.Panel */.p.Panel, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        unmount: false
                    }, !childIsFAQ && {
                        className: (0,es/* oneLine */.f9)(_templateObject3(), VARIANTS[variant].body, (ref1 = classNames === null || classNames === void 0 ? void 0 : classNames.body) !== null && ref1 !== void 0 ? ref1 : "")
                    }), {
                        children: isString ? /*#__PURE__*/ (0,jsx_runtime.jsx)(prose/* default */.Z, {
                            html: children,
                            className: "[&.prose]:u-body [&.prose]:u-body--xs [&.prose]:text-typo-secondary"
                        }) : children
                    }))
                ]
            });
        }
    });
};
Faq.displayName = "Faq";

;// CONCATENATED MODULE: ./components/molecules/faq/index.ts

/* harmony default export */ var faq = (Faq);


/***/ }),

/***/ 55520:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ two_column; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/common-tags/es/index.js + 40 modules
var es = __webpack_require__(40865);
// EXTERNAL MODULE: ./lib/utils/collections.tsx
var collections = __webpack_require__(27377);
;// CONCATENATED MODULE: ./components/molecules/two-column/TwoColumn.tsx





function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        grid grid-cols-1 md:grid-cols-[1fr_1fr]\n        ",
        "\n        ",
        "\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n              ",
        "\n              ",
        "\n            "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n              ",
        "\n              ",
        "\n            "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




/**
 * Permite intercambiar las columnas pero este comportamiento solo
 * ocurre en desktop, en mobile la primera columna siempre irá arriba.
 */ var TwoColumn = function(_param) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, _gap = _param.gap, gap = _gap === void 0 ? "" : _gap, _reverse = _param.reverse, reverse = _reverse === void 0 ? false : _reverse, children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "gap",
        "reverse",
        "children"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)((0,collections/* pickChild */.xC)(children, two_column.Rigth), 2), Right = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,collections/* pickChild */.xC)(children, two_column.Left), 2), Left = ref1[1];
    var /* TODO: Arreglar tipos */ /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */ /* @ts-ignore */ _className1, /* TODO: Arreglar tipos */ /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */ /* @ts-ignore */ _className2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,es/* oneLine */.f9)(_templateObject(), gap, className)
    }, rest), {
        children: [
            Left && /*#__PURE__*/ (0,jsx_runtime.jsx)(Left.type, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, Left.props), {
                className: (0,es/* oneLine */.f9)(_templateObject1(), reverse ? "order-2" : "order-1", (_className1 = Left.props.className) !== null && _className1 !== void 0 ? _className1 : "")
            })),
            Right && /*#__PURE__*/ (0,jsx_runtime.jsx)(Right.type, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, Right.props), {
                className: (0,es/* oneLine */.f9)(_templateObject2(), reverse ? "order-1" : "order-2", (_className2 = Right.props.className) !== null && _className2 !== void 0 ? _className2 : "")
            }))
        ]
    }));
};

;// CONCATENATED MODULE: ./components/molecules/two-column/child.tsx

var Column = function(param) {
    var tmp = param.as, HtmlTag = tmp === void 0 ? "div" : tmp, _className = param.className, className = _className === void 0 ? "" : _className, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTag, {
        className: "w-full ".concat(className),
        children: children
    });
};

;// CONCATENATED MODULE: ./components/molecules/two-column/index.ts


TwoColumn.Rigth = Column.bind({});
TwoColumn.Left = Column.bind({});
TwoColumn.Rigth.displayName = "TwoColumn.Right";
TwoColumn.Left.displayName = "TwoColumn.Left";
/* harmony default export */ var two_column = (TwoColumn);


/***/ }),

/***/ 47947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ info_seller; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/atoms/container/index.ts + 3 modules
var container = __webpack_require__(59203);
// EXTERNAL MODULE: ./components/molecules/two-column/index.ts + 2 modules
var two_column = __webpack_require__(55520);
;// CONCATENATED MODULE: ./components/organisms/info-seller/InfoSeller.tsx



/**
 * InfoSeller
 */ var InfoSeller = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, title = param.title, description = param.description, backgroundColor = param.backgroundColor, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
        wrapper: true,
        padding: "py-6 md:py-8 px-4",
        style: {
            backgroundColor: backgroundColor
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(two_column/* default */.Z, {
            className: "gap-6 ".concat(className),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(two_column/* default.Left */.Z.Left, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "u-headline u-headline--h2",
                                children: title
                            }),
                            description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "u-body u-body--s max-w-[472px] md:u-body--m",
                                dangerouslySetInnerHTML: {
                                    __html: description
                                }
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(two_column/* default.Rigth */.Z.Rigth, {
                    className: "flex items-center justify-end",
                    children: children
                })
            ]
        })
    });
};
InfoSeller.displayName = "InfoSeller";

;// CONCATENATED MODULE: ./components/organisms/info-seller/index.ts

/* harmony default export */ var info_seller = (InfoSeller);


/***/ }),

/***/ 23296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _molecules__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50153);
/* harmony import */ var _organisms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47947);
/* harmony import */ var _templates__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71888);
/* harmony import */ var _templates__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65900);
/* harmony import */ var _layouts_BaseLayout__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31247);







var Seller = function(param) {
    var _pageProps = param.pageProps, hero = _pageProps.hero, flexibleContent = _pageProps.flexibleContent, title = _pageProps.title, sellersMirakl = _pageProps.sellersMirakl;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_templates__WEBPACK_IMPORTED_MODULE_1__/* .HeroSlider */ .r, {
                hero: hero
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_templates__WEBPACK_IMPORTED_MODULE_2__/* .FlexibleContent */ .U, {
                flexible: flexibleContent === null || flexibleContent === void 0 ? void 0 : flexibleContent.flexible,
                type: "Seller"
            }),
            ((sellersMirakl === null || sellersMirakl === void 0 ? void 0 : sellersMirakl.estimatedDelivery) || (sellersMirakl === null || sellersMirakl === void 0 ? void 0 : (ref = sellersMirakl.shipping) === null || ref === void 0 ? void 0 : ref.price) || (sellersMirakl === null || sellersMirakl === void 0 ? void 0 : (ref1 = sellersMirakl.shipping) === null || ref1 === void 0 ? void 0 : ref1.isAlwaysFree) || (sellersMirakl === null || sellersMirakl === void 0 ? void 0 : (ref2 = sellersMirakl.shipping) === null || ref2 === void 0 ? void 0 : ref2.minAmount) || (sellersMirakl === null || sellersMirakl === void 0 ? void 0 : sellersMirakl.returnPolicy) || sellersMirakl.description || (sellersMirakl === null || sellersMirakl === void 0 ? void 0 : sellersMirakl.professionalInfo)) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_organisms__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                title: "Sobre ".concat(title),
                backgroundColor: "#FFF"
            }, sellersMirakl.description && {
                description: sellersMirakl.description
            }), {
                children: ((sellersMirakl === null || sellersMirakl === void 0 ? void 0 : sellersMirakl.estimatedDelivery) || (sellersMirakl === null || sellersMirakl === void 0 ? void 0 : (ref3 = sellersMirakl.shipping) === null || ref3 === void 0 ? void 0 : ref3.price) || (sellersMirakl === null || sellersMirakl === void 0 ? void 0 : (ref4 = sellersMirakl.shipping) === null || ref4 === void 0 ? void 0 : ref4.isAlwaysFree) || (sellersMirakl === null || sellersMirakl === void 0 ? void 0 : (ref5 = sellersMirakl.shipping) === null || ref5 === void 0 ? void 0 : ref5.minAmount) || (sellersMirakl === null || sellersMirakl === void 0 ? void 0 : sellersMirakl.returnPolicy) || (sellersMirakl === null || sellersMirakl === void 0 ? void 0 : sellersMirakl.professionalInfo)) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex w-full flex-col gap-2",
                    children: [
                        ((sellersMirakl === null || sellersMirakl === void 0 ? void 0 : sellersMirakl.estimatedDelivery) || (sellersMirakl === null || sellersMirakl === void 0 ? void 0 : (ref6 = sellersMirakl.shipping) === null || ref6 === void 0 ? void 0 : ref6.price) || (sellersMirakl === null || sellersMirakl === void 0 ? void 0 : (ref7 = sellersMirakl.shipping) === null || ref7 === void 0 ? void 0 : ref7.isAlwaysFree) || (sellersMirakl === null || sellersMirakl === void 0 ? void 0 : (ref8 = sellersMirakl.shipping) === null || ref8 === void 0 ? void 0 : ref8.minAmount)) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_molecules__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            question: "1. Env\xedos",
                            open: true,
                            children: [
                                sellersMirakl.estimatedDelivery && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "!text-typo-primary",
                                    children: [
                                        "Entrega estimada en ",
                                        sellersMirakl.estimatedDelivery,
                                        " d\xedas."
                                    ]
                                }),
                                sellersMirakl.shipping.isAlwaysFree || sellersMirakl.shipping.minAmount ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        sellersMirakl.shipping.price && !sellersMirakl.shipping.isAlwaysFree && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            className: "!text-typo-primary",
                                            children: [
                                                "Gastos de env\xedo: ",
                                                sellersMirakl.shipping.price,
                                                "."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            className: "!text-typo-primary",
                                            children: [
                                                "Env\xedo gratis",
                                                sellersMirakl.shipping.minAmount && !sellersMirakl.shipping.isAlwaysFree ? " a partir de ".concat(sellersMirakl.shipping.minAmount) : "",
                                                "."
                                            ]
                                        })
                                    ]
                                }) : sellersMirakl.shipping.price && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "!text-typo-primary",
                                    children: [
                                        "Gastos de env\xedo: ",
                                        sellersMirakl.shipping.price,
                                        "."
                                    ]
                                })
                            ]
                        }),
                        (sellersMirakl === null || sellersMirakl === void 0 ? void 0 : sellersMirakl.returnPolicy) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_molecules__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            question: "2. Pol\xedtica de devoluciones",
                            children: sellersMirakl.returnPolicy
                        }),
                        (sellersMirakl === null || sellersMirakl === void 0 ? void 0 : sellersMirakl.professionalInfo) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_molecules__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            question: "3. Informaci\xf3n de la empresa",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    (sellersMirakl === null || sellersMirakl === void 0 ? void 0 : (ref9 = sellersMirakl.professionalInfo) === null || ref9 === void 0 ? void 0 : ref9.corporateName) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        children: [
                                            "Nombre de la empresa:",
                                            " ",
                                            sellersMirakl.professionalInfo.corporateName
                                        ]
                                    }),
                                    (sellersMirakl === null || sellersMirakl === void 0 ? void 0 : sellersMirakl.professionalInfo.identificationNumber) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        children: [
                                            "CIF / NIF:",
                                            " ",
                                            sellersMirakl.professionalInfo.identificationNumber
                                        ]
                                    }),
                                    (sellersMirakl === null || sellersMirakl === void 0 ? void 0 : sellersMirakl.professionalInfo.taxIdentificationNumber) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        children: [
                                            "N\xfamero de IVA intracomunitario:",
                                            " ",
                                            sellersMirakl.professionalInfo.taxIdentificationNumber
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }))
        ]
    });
};
Seller.getLayout = _layouts_BaseLayout__WEBPACK_IMPORTED_MODULE_7__/* .getBaseLayout */ .W;
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Seller);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2033,7677,1247,1888,9774,2888,179], function() { return __webpack_exec__(26699); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);